import { useTranslation } from 'react-i18next';

export default function HowItWorks() {
  const { t } = useTranslation();

  const steps = [
    { num: '01', text: t('how_step1'), icon: 'ri-list-check' },
    { num: '02', text: t('how_step2'), icon: 'ri-search-line' },
    { num: '03', text: t('how_step3'), icon: 'ri-link' },
    { num: '04', text: t('how_step4'), icon: 'ri-camera-line' },
    { num: '05', text: t('how_step5'), icon: 'ri-scales-3-line' },
    { num: '06', text: t('how_step6'), icon: 'ri-check-double-line' },
  ];

  return (
    <section className="py-12 md:py-16 bg-stone-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-800">
            {t('how_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto">
          {steps.map((step) => (
            <div
              key={step.num}
              className="flex items-start gap-4 p-5 rounded-xl bg-white border border-stone-200 hover:border-emerald-200 transition-colors"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-emerald-50 text-emerald-600 shrink-0">
                <i className={`${step.icon} text-lg`} />
              </div>
              <div>
                <span className="text-xs font-bold text-emerald-600 uppercase tracking-wider">
                  {step.num}
                </span>
                <p className="text-sm md:text-base text-stone-700 mt-1 font-medium">
                  {step.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}